export const TRANSLATED_COUNTRIES = {
  Afghanistan: {
    fr: "Afghanistan",
    en: "Afghanistan",
    es: "Afganistán",
    it: "Afghanistan",
    de: "Afghanistan",
  },
  "Afrique du Sud": {
    fr: "Afrique du Sud",
    en: "South Africa",
    es: "Sudáfrica",
    it: "Sudafrica",
    de: "Südafrika",
  },
  Albanie: {
    fr: "Albanie",
    en: "Albania",
    es: "Albania",
    it: "Albania",
    de: "Albanien",
  },
  Algérie: {
    fr: "Algérie",
    en: "Algeria",
    es: "Argelia",
    it: "Algeria",
    de: "Algerien",
  },
  Allemagne: {
    fr: "Allemagne",
    en: "Germany",
    es: "Alemania",
    it: "Germania",
    de: "Deutschland",
  },
  Andorre: {
    fr: "Andorre",
    en: "Andorra",
    es: "Andorra",
    it: "Andorra",
    de: "Andorra",
  },
  Angola: {
    fr: "Angola",
    en: "Angola",
    es: "Angola",
    it: "Angola",
    de: "Angola",
  },
  "Antigua-et-Barbuda": {
    fr: "Antigua-et-Barbuda",
    en: "Antigua and Barbuda",
    es: "Antigua y Barbuda",
    it: "Antigua e Barbuda",
    de: "Antigua und Barbuda",
  },
  "Arabie saoudite": {
    fr: "Arabie saoudite",
    en: "Saudi Arabia",
    es: "Arabia Saudita",
    it: "Arabia Saudita",
    de: "Saudi-Arabien",
  },
  Argentine: {
    fr: "Argentine",
    en: "Argentina",
    es: "Argentina",
    it: "Argentina",
    de: "Argentinien",
  },
  Arménie: {
    fr: "Arménie",
    en: "Armenia",
    es: "Armenia",
    it: "Armenia",
    de: "Armenien",
  },
  Australie: {
    fr: "Australie",
    en: "Australia",
    es: "Australia",
    it: "Australia",
    de: "Australien",
  },
  Autriche: {
    fr: "Autriche",
    en: "Austria",
    es: "Austria",
    it: "Austria",
    de: "Österreich",
  },
  Azerbaïdjan: {
    fr: "Azerbaïdjan",
    en: "Azerbaijan",
    es: "Azerbaiyán",
    it: "Azerbaigian",
    de: "Aserbaidschan",
  },
  Bahamas: {
    fr: "Bahamas",
    en: "Bahamas",
    es: "Bahamas",
    it: "Bahamas",
    de: "Bahamas",
  },
  Bahreïn: {
    fr: "Bahreïn",
    en: "Bahrain",
    es: "Baréin",
    it: "Bahrein",
    de: "Bahrain",
  },
  Bangladesh: {
    fr: "Bangladesh",
    en: "Bangladesh",
    es: "Bangladés",
    it: "Bangladesh",
    de: "Bangladesch",
  },
  Barbade: {
    fr: "Barbade",
    en: "Barbados",
    es: "Barbados",
    it: "Barbados",
    de: "Barbados",
  },
  Belgique: {
    fr: "Belgique",
    en: "Belgium",
    es: "Bélgica",
    it: "Belgio",
    de: "Belgien",
  },
  Belize: {
    fr: "Belize",
    en: "Belize",
    es: "Belice",
    it: "Belize",
    de: "Belize",
  },
  Bénin: {
    fr: "Bénin",
    en: "Benin",
    es: "Benín",
    it: "Benin",
    de: "Benin",
  },
  Bhoutan: {
    fr: "Bhoutan",
    en: "Bhutan",
    es: "Bután",
    it: "Bhutan",
    de: "Bhutan",
  },
  Biélorussie: {
    fr: "Biélorussie",
    en: "Belarus",
    es: "Bielorrusia",
    it: "Bielorussia",
    de: "Weißrussland",
  },
  "Birmanie (Myanmar)": {
    fr: "Birmanie (Myanmar)",
    en: "Myanmar (Burma)",
    es: "Myanmar (Birmania)",
    it: "Myanmar (Birmania)",
    de: "Myanmar (Birma)",
  },
  Bolivie: {
    fr: "Bolivie",
    en: "Bolivia",
    es: "Bolivia",
    it: "Bolivia",
    de: "Bolivien",
  },
  "Bosnie-Herzégovine": {
    fr: "Bosnie-Herzégovine",
    en: "Bosnia and Herzegovina",
    es: "Bosnia y Herzegovina",
    it: "Bosnia ed Erzegovina",
    de: "Bosnien und Herzegowina",
  },
  Botswana: {
    fr: "Botswana",
    en: "Botswana",
    es: "Botsuana",
    it: "Botswana",
    de: "Botswana",
  },
  Brésil: {
    fr: "Brésil",
    en: "Brazil",
    es: "Brasil",
    it: "Brasile",
    de: "Brasilien",
  },
  Brunei: {
    fr: "Brunei",
    en: "Brunei",
    es: "Brunéi",
    it: "Brunei",
    de: "Brunei",
  },
  Bulgarie: {
    fr: "Bulgarie",
    en: "Bulgaria",
    es: "Bulgaria",
    it: "Bulgaria",
    de: "Bulgarien",
  },
  "Burkina Faso": {
    fr: "Burkina Faso",
    en: "Burkina Faso",
    es: "Burkina Faso",
    it: "Burkina Faso",
    de: "Burkina Faso",
  },
  Burundi: {
    fr: "Burundi",
    en: "Burundi",
    es: "Burundi",
    it: "Burundi",
    de: "Burundi",
  },
  Cambodge: {
    fr: "Cambodge",
    en: "Cambodia",
    es: "Camboya",
    it: "Cambogia",
    de: "Kambodscha",
  },
  Cameroun: {
    fr: "Cameroun",
    en: "Cameroon",
    es: "Camerún",
    it: "Camerun",
    de: "Kamerun",
  },
  Canada: {
    fr: "Canada",
    en: "Canada",
    es: "Canadá",
    it: "Canada",
    de: "Kanada",
  },
  "Cap-Vert": {
    fr: "Cap-Vert",
    en: "Cape Verde",
    es: "Cabo Verde",
    it: "Capo Verde",
    de: "Kap Verde",
  },
  Chili: {
    fr: "Chili",
    en: "Chile",
    es: "Chile",
    it: "Cile",
    de: "Chile",
  },
  Chine: {
    fr: "Chine",
    en: "China",
    es: "China",
    it: "Cina",
    de: "China",
  },
  Chypre: {
    fr: "Chypre",
    en: "Cyprus",
    es: "Chipre",
    it: "Cipro",
    de: "Zypern",
  },
  Colombie: {
    fr: "Colombie",
    en: "Colombia",
    es: "Colombia",
    it: "Colombia",
    de: "Kolumbien",
  },
  Comores: {
    fr: "Comores",
    en: "Comoros",
    es: "Comoras",
    it: "Comore",
    de: "Komoren",
  },
  "Congo (République du)": {
    fr: "Congo (République du)",
    en: "Republic of the Congo",
    es: "República del Congo",
    it: "Repubblica del Congo",
    de: "Republik Kongo",
  },
  "Congo (République démocratique du)": {
    fr: "Congo (République démocratique du)",
    en: "Democratic Republic of the Congo",
    es: "República Democrática del Congo",
    it: "Repubblica Democratica del Congo",
    de: "Demokratische Republik Kongo",
  },
  "Corée du Nord": {
    fr: "Corée du Nord",
    en: "North Korea",
    es: "Corea del Norte",
    it: "Corea del Nord",
    de: "Nordkorea",
  },
  "Corée du Sud": {
    fr: "Corée du Sud",
    en: "South Korea",
    es: "Corea del Sur",
    it: "Corea del Sud",
    de: "Südkorea",
  },
  "Costa Rica": {
    fr: "Costa Rica",
    en: "Costa Rica",
    es: "Costa Rica",
    it: "Costa Rica",
    de: "Costa Rica",
  },
  "Côte d'Ivoire": {
    fr: "Côte d'Ivoire",
    en: "Ivory Coast",
    es: "Costa de Marfil",
    it: "Costa d'Avorio",
    de: "Elfenbeinküste",
  },
  Croatie: {
    fr: "Croatie",
    en: "Croatia",
    es: "Croacia",
    it: "Croazia",
    de: "Kroatien",
  },
  Cuba: {
    fr: "Cuba",
    en: "Cuba",
    es: "Cuba",
    it: "Cuba",
    de: "Kuba",
  },
  Danemark: {
    fr: "Danemark",
    en: "Denmark",
    es: "Dinamarca",
    it: "Danimarca",
    de: "Dänemark",
  },
  Djibouti: {
    fr: "Djibouti",
    en: "Djibouti",
    es: "Yibuti",
    it: "Gibuti",
    de: "Dschibuti",
  },
  Dominique: {
    fr: "Dominique",
    en: "Dominica",
    es: "Dominica",
    it: "Dominica",
    de: "Dominica",
  },
  Égypte: {
    fr: "Égypte",
    en: "Egypt",
    es: "Egipto",
    it: "Egitto",
    de: "Ägypten",
  },
  "Émirats arabes unis": {
    fr: "Émirats arabes unis",
    en: "United Arab Emirates",
    es: "Emiratos Árabes Unidos",
    it: "Emirati Arabi Uniti",
    de: "Vereinigte Arabische Emirate",
  },
  Équateur: {
    fr: "Équateur",
    en: "Ecuador",
    es: "Ecuador",
    it: "Ecuador",
    de: "Ecuador",
  },
  Érythrée: {
    fr: "Érythrée",
    en: "Eritrea",
    es: "Eritrea",
    it: "Eritrea",
    de: "Eritrea",
  },
  Espagne: {
    fr: "Espagne",
    en: "Spain",
    es: "España",
    it: "Spagna",
    de: "Spanien",
  },
  Estonie: {
    fr: "Estonie",
    en: "Estonia",
    es: "Estonia",
    it: "Estonia",
    de: "Estland",
  },
  Eswatini: {
    fr: "Eswatini",
    en: "Eswatini",
    es: "Esuatini",
    it: "Eswatini",
    de: "Eswatini",
  },
  "États-Unis": {
    fr: "États-Unis",
    en: "United States",
    es: "Estados Unidos",
    it: "Stati Uniti",
    de: "Vereinigte Staaten",
  },
  Éthiopie: {
    fr: "Éthiopie",
    en: "Ethiopia",
    es: "Etiopía",
    it: "Etiopia",
    de: "Äthiopien",
  },
  Fidji: {
    fr: "Fidji",
    en: "Fiji",
    es: "Fiyi",
    it: "Figi",
    de: "Fidschi",
  },
  Finlande: {
    fr: "Finlande",
    en: "Finland",
    es: "Finlandia",
    it: "Finlandia",
    de: "Finnland",
  },
  France: {
    fr: "France",
    en: "France",
    es: "Francia",
    it: "Francia",
    de: "Frankreich",
  },
  Gabon: {
    fr: "Gabon",
    en: "Gabon",
    es: "Gabón",
    it: "Gabon",
    de: "Gabun",
  },
  Gambie: {
    fr: "Gambie",
    en: "Gambia",
    es: "Gambia",
    it: "Gambia",
    de: "Gambia",
  },
  Géorgie: {
    fr: "Géorgie",
    en: "Georgia",
    es: "Georgia",
    it: "Georgia",
    de: "Georgien",
  },
  Ghana: {
    fr: "Ghana",
    en: "Ghana",
    es: "Ghana",
    it: "Ghana",
    de: "Ghana",
  },
  Grèce: {
    fr: "Grèce",
    en: "Greece",
    es: "Grecia",
    it: "Grecia",
    de: "Griechenland",
  },
  Grenade: {
    fr: "Grenade",
    en: "Grenada",
    es: "Granada",
    it: "Grenada",
    de: "Grenada",
  },
  Guatemala: {
    fr: "Guatemala",
    en: "Guatemala",
    es: "Guatemala",
    it: "Guatemala",
    de: "Guatemala",
  },
  Guinée: {
    fr: "Guinée",
    en: "Guinea",
    es: "Guinea",
    it: "Guinea",
    de: "Guinea",
  },
  "Guinée-Bissau": {
    fr: "Guinée-Bissau",
    en: "Guinea-Bissau",
    es: "Guinea-Bisáu",
    it: "Guinea-Bissau",
    de: "Guinea-Bissau",
  },
  "Guinée équatoriale": {
    fr: "Guinée équatoriale",
    en: "Equatorial Guinea",
    es: "Guinea Ecuatorial",
    it: "Guinea Equatoriale",
    de: "Äquatorialguinea",
  },
  Guyana: {
    fr: "Guyana",
    en: "Guyana",
    es: "Guyana",
    it: "Guyana",
    de: "Guyana",
  },
  Haïti: {
    fr: "Haïti",
    en: "Haiti",
    es: "Haití",
    it: "Haiti",
    de: "Haiti",
  },
  Honduras: {
    fr: "Honduras",
    en: "Honduras",
    es: "Honduras",
    it: "Honduras",
    de: "Honduras",
  },
  Hongrie: {
    fr: "Hongrie",
    en: "Hungary",
    es: "Hungría",
    it: "Ungheria",
    de: "Ungarn",
  },
  "Îles Marshall": {
    fr: "Îles Marshall",
    en: "Marshall Islands",
    es: "Islas Marshall",
    it: "Isole Marshall",
    de: "Marshallinseln",
  },
  Inde: {
    fr: "Inde",
    en: "India",
    es: "India",
    it: "India",
    de: "Indien",
  },
  Indonésie: {
    fr: "Indonésie",
    en: "Indonesia",
    es: "Indonesia",
    it: "Indonesia",
    de: "Indonesien",
  },
  Irak: {
    fr: "Irak",
    en: "Iraq",
    es: "Irak",
    it: "Iraq",
    de: "Irak",
  },
  Iran: {
    fr: "Iran",
    en: "Iran",
    es: "Irán",
    it: "Iran",
    de: "Iran",
  },
  Irlande: {
    fr: "Irlande",
    en: "Ireland",
    es: "Irlanda",
    it: "Irlanda",
    de: "Irland",
  },
  Islande: {
    fr: "Islande",
    en: "Iceland",
    es: "Islandia",
    it: "Islanda",
    de: "Island",
  },
  Israël: {
    fr: "Israël",
    en: "Israel",
    es: "Israel",
    it: "Israele",
    de: "Israel",
  },
  Italie: {
    fr: "Italie",
    en: "Italy",
    es: "Italia",
    it: "Italia",
    de: "Italien",
  },
  Jamaïque: {
    fr: "Jamaïque",
    en: "Jamaica",
    es: "Jamaica",
    it: "Giamaica",
    de: "Jamaika",
  },
  Japon: {
    fr: "Japon",
    en: "Japan",
    es: "Japón",
    it: "Giappone",
    de: "Japan",
  },
  Jordanie: {
    fr: "Jordanie",
    en: "Jordan",
    es: "Jordania",
    it: "Giordania",
    de: "Jordanien",
  },
  Kazakhstan: {
    fr: "Kazakhstan",
    en: "Kazakhstan",
    es: "Kazajistán",
    it: "Kazakistan",
    de: "Kasachstan",
  },
  Kenya: {
    fr: "Kenya",
    en: "Kenya",
    es: "Kenia",
    it: "Kenya",
    de: "Kenia",
  },
  Kirghizistan: {
    fr: "Kirghizistan",
    en: "Kyrgyzstan",
    es: "Kirguistán",
    it: "Kirghizistan",
    de: "Kirgisistan",
  },
  Kiribati: {
    fr: "Kiribati",
    en: "Kiribati",
    es: "Kiribati",
    it: "Kiribati",
    de: "Kiribati",
  },
  Koweït: {
    fr: "Koweït",
    en: "Kuwait",
    es: "Kuwait",
    it: "Kuwait",
    de: "Kuwait",
  },
  Laos: {
    fr: "Laos",
    en: "Laos",
    es: "Laos",
    it: "Laos",
    de: "Laos",
  },
  Lesotho: {
    fr: "Lesotho",
    en: "Lesotho",
    es: "Lesoto",
    it: "Lesotho",
    de: "Lesotho",
  },
  Lettonie: {
    fr: "Lettonie",
    en: "Latvia",
    es: "Letonia",
    it: "Lettonia",
    de: "Lettland",
  },
  Liban: {
    fr: "Liban",
    en: "Lebanon",
    es: "Líbano",
    it: "Libano",
    de: "Libanon",
  },
  Liberia: {
    fr: "Liberia",
    en: "Liberia",
    es: "Liberia",
    it: "Liberia",
    de: "Liberia",
  },
  Libye: {
    fr: "Libye",
    en: "Libya",
    es: "Libia",
    it: "Libia",
    de: "Libyen",
  },
  Liechtenstein: {
    fr: "Liechtenstein",
    en: "Liechtenstein",
    es: "Liechtenstein",
    it: "Liechtenstein",
    de: "Liechtenstein",
  },
  Lituanie: {
    fr: "Lituanie",
    en: "Lithuania",
    es: "Lituania",
    it: "Lituania",
    de: "Litauen",
  },
  Luxembourg: {
    fr: "Luxembourg",
    en: "Luxembourg",
    es: "Luxemburgo",
    it: "Lussemburgo",
    de: "Luxemburg",
  },
  "Macédoine du Nord": {
    fr: "Macédoine du Nord",
    en: "North Macedonia",
    es: "Macedonia del Norte",
    it: "Macedonia del Nord",
    de: "Nordmazedonien",
  },
  Madagascar: {
    fr: "Madagascar",
    en: "Madagascar",
    es: "Madagascar",
    it: "Madagascar",
    de: "Madagaskar",
  },
  Malaisie: {
    fr: "Malaisie",
    en: "Malaysia",
    es: "Malasia",
    it: "Malaysia",
    de: "Malaysia",
  },
  Malawi: {
    fr: "Malawi",
    en: "Malawi",
    es: "Malaui",
    it: "Malawi",
    de: "Malawi",
  },
  Maldives: {
    fr: "Maldives",
    en: "Maldives",
    es: "Maldivas",
    it: "Maldive",
    de: "Malediven",
  },
  Mali: {
    fr: "Mali",
    en: "Mali",
    es: "Mali",
    it: "Mali",
    de: "Mali",
  },
  Malte: {
    fr: "Malte",
    en: "Malta",
    es: "Malta",
    it: "Malta",
    de: "Malta",
  },
  Maroc: {
    fr: "Maroc",
    en: "Morocco",
    es: "Marruecos",
    it: "Marocco",
    de: "Marokko",
  },
  Maurice: {
    fr: "Maurice",
    en: "Mauritius",
    es: "Mauricio",
    it: "Mauritius",
    de: "Mauritius",
  },
  Mauritanie: {
    fr: "Mauritanie",
    en: "Mauritania",
    es: "Mauritania",
    it: "Mauritania",
    de: "Mauretanien",
  },
  Mexique: {
    fr: "Mexique",
    en: "Mexico",
    es: "México",
    it: "Messico",
    de: "Mexiko",
  },
  Micronésie: {
    fr: "Micronésie",
    en: "Micronesia",
    es: "Micronesia",
    it: "Micronesia",
    de: "Mikronesien",
  },
  Moldavie: {
    fr: "Moldavie",
    en: "Moldova",
    es: "Moldavia",
    it: "Moldavia",
    de: "Moldau",
  },
  Monaco: {
    fr: "Monaco",
    en: "Monaco",
    es: "Mónaco",
    it: "Monaco",
    de: "Monaco",
  },
  Mongolie: {
    fr: "Mongolie",
    en: "Mongolia",
    es: "Mongolia",
    it: "Mongolia",
    de: "Mongolei",
  },
  Monténégro: {
    fr: "Monténégro",
    en: "Montenegro",
    es: "Montenegro",
    it: "Montenegro",
    de: "Montenegro",
  },
  Mozambique: {
    fr: "Mozambique",
    en: "Mozambique",
    es: "Mozambique",
    it: "Mozambico",
    de: "Mosambik",
  },
  Namibie: {
    fr: "Namibie",
    en: "Namibia",
    es: "Namibia",
    it: "Namibia",
    de: "Namibia",
  },
  Nauru: {
    fr: "Nauru",
    en: "Nauru",
    es: "Nauru",
    it: "Nauru",
    de: "Nauru",
  },
  Népal: {
    fr: "Népal",
    en: "Nepal",
    es: "Nepal",
    it: "Nepal",
    de: "Nepal",
  },
  Nicaragua: {
    fr: "Nicaragua",
    en: "Nicaragua",
    es: "Nicaragua",
    it: "Nicaragua",
    de: "Nicaragua",
  },
  Niger: {
    fr: "Niger",
    en: "Niger",
    es: "Níger",
    it: "Niger",
    de: "Niger",
  },
  Nigeria: {
    fr: "Nigeria",
    en: "Nigeria",
    es: "Nigeria",
    it: "Nigeria",
    de: "Nigeria",
  },
  Norvège: {
    fr: "Norvège",
    en: "Norway",
    es: "Noruega",
    it: "Norvegia",
    de: "Norwegen",
  },
  "Nouvelle-Zélande": {
    fr: "Nouvelle-Zélande",
    en: "New Zealand",
    es: "Nueva Zelanda",
    it: "Nuova Zelanda",
    de: "Neuseeland",
  },
  Oman: {
    fr: "Oman",
    en: "Oman",
    es: "Omán",
    it: "Oman",
    de: "Oman",
  },
  Ouganda: {
    fr: "Ouganda",
    en: "Uganda",
    es: "Uganda",
    it: "Uganda",
    de: "Uganda",
  },
  Ouzbékistan: {
    fr: "Ouzbékistan",
    en: "Uzbekistan",
    es: "Uzbekistán",
    it: "Uzbekistan",
    de: "Usbekistan",
  },
  Pakistan: {
    fr: "Pakistan",
    en: "Pakistan",
    es: "Pakistán",
    it: "Pakistan",
    de: "Pakistan",
  },
  Palaos: {
    fr: "Palaos",
    en: "Palau",
    es: "Palaos",
    it: "Palau",
    de: "Palau",
  },
  Panama: {
    fr: "Panama",
    en: "Panama",
    es: "Panamá",
    it: "Panama",
    de: "Panama",
  },
  "Papouasie-Nouvelle-Guinée": {
    fr: "Papouasie-Nouvelle-Guinée",
    en: "Papua New Guinea",
    es: "Papúa Nueva Guinea",
    it: "Papua Nuova Guinea",
    de: "Papua-Neuguinea",
  },
  Paraguay: {
    fr: "Paraguay",
    en: "Paraguay",
    es: "Paraguay",
    it: "Paraguay",
    de: "Paraguay",
  },
  "Pays-Bas": {
    fr: "Pays-Bas",
    en: "Netherlands",
    es: "Países Bajos",
    it: "Paesi Bassi",
    de: "Niederlande",
  },
  Pérou: {
    fr: "Pérou",
    en: "Peru",
    es: "Perú",
    it: "Perù",
    de: "Peru",
  },
  Philippines: {
    fr: "Philippines",
    en: "Philippines",
    es: "Filipinas",
    it: "Filippine",
    de: "Philippinen",
  },
  Pologne: {
    fr: "Pologne",
    en: "Poland",
    es: "Polonia",
    it: "Polonia",
    de: "Polen",
  },
  Portugal: {
    fr: "Portugal",
    en: "Portugal",
    es: "Portugal",
    it: "Portogallo",
    de: "Portugal",
  },
  Qatar: {
    fr: "Qatar",
    en: "Qatar",
    es: "Catar",
    it: "Qatar",
    de: "Katar",
  },
  "République centrafricaine": {
    fr: "République centrafricaine",
    en: "Central African Republic",
    es: "República Centroafricana",
    it: "Repubblica Centrafricana",
    de: "Zentralafrikanische Republik",
  },
  "République dominicaine": {
    fr: "République dominicaine",
    en: "Dominican Republic",
    es: "República Dominicana",
    it: "Repubblica Dominicana",
    de: "Dominikanische Republik",
  },
  Roumanie: {
    fr: "Roumanie",
    en: "Romania",
    es: "Rumania",
    it: "Romania",
    de: "Rumänien",
  },
  "Royaume-Uni": {
    fr: "Royaume-Uni",
    en: "United Kingdom",
    es: "Reino Unido",
    it: "Regno Unito",
    de: "Vereinigtes Königreich",
  },
  Russie: {
    fr: "Russie",
    en: "Russia",
    es: "Rusia",
    it: "Russia",
    de: "Russland",
  },
  Rwanda: {
    fr: "Rwanda",
    en: "Rwanda",
    es: "Ruanda",
    it: "Ruanda",
    de: "Ruanda",
  },
  "Saint-Kitts-et-Nevis": {
    fr: "Saint-Kitts-et-Nevis",
    en: "Saint Kitts and Nevis",
    es: "San Cristóbal y Nieves",
    it: "Saint Kitts e Nevis",
    de: "St. Kitts und Nevis",
  },
  "Saint-Vincent-et-les-Grenadines": {
    fr: "Saint-Vincent-et-les-Grenadines",
    en: "Saint Vincent and the Grenadines",
    es: "San Vicente y las Granadinas",
    it: "Saint Vincent e Grenadine",
    de: "St. Vincent und die Grenadinen",
  },
  "Sainte-Lucie": {
    fr: "Sainte-Lucie",
    en: "Saint Lucia",
    es: "Santa Lucía",
    it: "Saint Lucia",
    de: "St. Lucia",
  },
  "Saint-Marin": {
    fr: "Saint-Marin",
    en: "San Marino",
    es: "San Marino",
    it: "San Marino",
    de: "San Marino",
  },
  "Salomon (Îles)": {
    fr: "Salomon (Îles)",
    en: "Solomon Islands",
    es: "Islas Salomón",
    it: "Isole Salomone",
    de: "Salomonen",
  },
  Salvador: {
    fr: "Salvador",
    en: "El Salvador",
    es: "El Salvador",
    it: "El Salvador",
    de: "El Salvador",
  },
  Samoa: {
    fr: "Samoa",
    en: "Samoa",
    es: "Samoa",
    it: "Samoa",
    de: "Samoa",
  },
  "Sao Tomé-et-Principe": {
    fr: "Sao Tomé-et-Principe",
    en: "Sao Tome and Principe",
    es: "Santo Tomé y Príncipe",
    it: "São Tomé e Príncipe",
    de: "São Tomé und Príncipe",
  },
  Sénégal: {
    fr: "Sénégal",
    en: "Senegal",
    es: "Senegal",
    it: "Senegal",
    de: "Senegal",
  },
  Serbie: {
    fr: "Serbie",
    en: "Serbia",
    es: "Serbia",
    it: "Serbia",
    de: "Serbien",
  },
  Seychelles: {
    fr: "Seychelles",
    en: "Seychelles",
    es: "Seychelles",
    it: "Seychelles",
    de: "Seychellen",
  },
  "Sierra Leone": {
    fr: "Sierra Leone",
    en: "Sierra Leone",
    es: "Sierra Leona",
    it: "Sierra Leone",
    de: "Sierra Leone",
  },
  Singapour: {
    fr: "Singapour",
    en: "Singapore",
    es: "Singapur",
    it: "Singapore",
    de: "Singapur",
  },
  Slovaquie: {
    fr: "Slovaquie",
    en: "Slovakia",
    es: "Eslovaquia",
    it: "Slovacchia",
    de: "Slowakei",
  },
  Slovénie: {
    fr: "Slovénie",
    en: "Slovenia",
    es: "Eslovenia",
    it: "Slovenia",
    de: "Slowenien",
  },
  Somalie: {
    fr: "Somalie",
    en: "Somalia",
    es: "Somalia",
    it: "Somalia",
    de: "Somalia",
  },
  Soudan: {
    fr: "Soudan",
    en: "Sudan",
    es: "Sudán",
    it: "Sudan",
    de: "Sudan",
  },
  "Soudan du Sud": {
    fr: "Soudan du Sud",
    en: "South Sudan",
    es: "Sudán del Sur",
    it: "Sud Sudan",
    de: "Südsudan",
  },
  "Sri Lanka": {
    fr: "Sri Lanka",
    en: "Sri Lanka",
    es: "Sri Lanka",
    it: "Sri Lanka",
    de: "Sri Lanka",
  },
  Suède: {
    fr: "Suède",
    en: "Sweden",
    es: "Suecia",
    it: "Svezia",
    de: "Schweden",
  },
  Suisse: {
    fr: "Suisse",
    en: "Switzerland",
    es: "Suiza",
    it: "Svizzera",
    de: "Schweiz",
  },
  Suriname: {
    fr: "Suriname",
    en: "Suriname",
    es: "Surinam",
    it: "Suriname",
    de: "Suriname",
  },
  Syrie: {
    fr: "Syrie",
    en: "Syria",
    es: "Siria",
    it: "Siria",
    de: "Syrien",
  },
  Tadjikistan: {
    fr: "Tadjikistan",
    en: "Tajikistan",
    es: "Tayikistán",
    it: "Tagikistan",
    de: "Tadschikistan",
  },
  Tanzanie: {
    fr: "Tanzanie",
    en: "Tanzania",
    es: "Tanzania",
    it: "Tanzania",
    de: "Tansania",
  },
  Tchad: {
    fr: "Tchad",
    en: "Chad",
    es: "Chad",
    it: "Ciad",
    de: "Tschad",
  },
  "Tchéquie (République tchèque)": {
    fr: "Tchéquie (République tchèque)",
    en: "Czech Republic",
    es: "República Checa",
    it: "Repubblica Ceca",
    de: "Tschechien",
  },
  Thaïlande: {
    fr: "Thaïlande",
    en: "Thailand",
    es: "Tailandia",
    it: "Thailandia",
    de: "Thailand",
  },
  "Timor oriental": {
    fr: "Timor oriental",
    en: "Timor-Leste",
    es: "Timor Oriental",
    it: "Timor Est",
    de: "Osttimor",
  },
  Togo: {
    fr: "Togo",
    en: "Togo",
    es: "Togo",
    it: "Togo",
    de: "Togo",
  },
  Tonga: {
    fr: "Tonga",
    en: "Tonga",
    es: "Tonga",
    it: "Tonga",
    de: "Tonga",
  },
  "Trinité-et-Tobago": {
    fr: "Trinité-et-Tobago",
    en: "Trinidad and Tobago",
    es: "Trinidad y Tobago",
    it: "Trinidad e Tobago",
    de: "Trinidad und Tobago",
  },
  Tunisie: {
    fr: "Tunisie",
    en: "Tunisia",
    es: "Túnez",
    it: "Tunisia",
    de: "Tunesien",
  },
  Turkménistan: {
    fr: "Turkménistan",
    en: "Turkmenistan",
    es: "Turkmenistán",
    it: "Turkmenistan",
    de: "Turkmenistan",
  },
  Turquie: {
    fr: "Turquie",
    en: "Turkey",
    es: "Turquía",
    it: "Turchia",
    de: "Türkei",
  },
  Tuvalu: {
    fr: "Tuvalu",
    en: "Tuvalu",
    es: "Tuvalu",
    it: "Tuvalu",
    de: "Tuvalu",
  },
  Ukraine: {
    fr: "Ukraine",
    en: "Ukraine",
    es: "Ucrania",
    it: "Ucraina",
    de: "Ukraine",
  },
  Uruguay: {
    fr: "Uruguay",
    en: "Uruguay",
    es: "Uruguay",
    it: "Uruguay",
    de: "Uruguay",
  },
  Vanuatu: {
    fr: "Vanuatu",
    en: "Vanuatu",
    es: "Vanuatu",
    it: "Vanuatu",
    de: "Vanuatu",
  },
  Vatican: {
    fr: "Vatican",
    en: "Vatican City",
    es: "Ciudad del Vaticano",
    it: "Città del Vaticano",
    de: "Vatikanstadt",
  },
  Venezuela: {
    fr: "Venezuela",
    en: "Venezuela",
    es: "Venezuela",
    it: "Venezuela",
    de: "Venezuela",
  },
  "Viêt Nam": {
    fr: "Viêt Nam",
    en: "Vietnam",
    es: "Vietnam",
    it: "Vietnam",
    de: "Vietnam",
  },
  Yémen: {
    fr: "Yémen",
    en: "Yemen",
    es: "Yemen",
    it: "Yemen",
    de: "Jemen",
  },
  Zambie: {
    fr: "Zambie",
    en: "Zambia",
    es: "Zambia",
    it: "Zambia",
    de: "Sambia",
  },
  Zimbabwe: {
    fr: "Zimbabwe",
    en: "Zimbabwe",
    es: "Zimbabue",
    it: "Zimbabwe",
    de: "Simbabwe",
  },
} as const;
